



































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { CONSTANTS, EOrigin, EUserResponsibilities, EUserStatus, IChain, IFacility } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import TextArea from '@/components/inputs/TextArea.vue'
import { Debounce } from 'vue-debounce-decorator'
import { FacilityModule } from '@/store/modules/facility.module'
import Avatar from '@/components/Avatar.vue'

@Component({
  components: {
    Card,
    Switcher,
    Icon,
    TextArea,
    Avatar
  }
})
export default class UserDetails extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store);
  EUserStatus: any = EUserStatus;
  get user () {
    return this.$store.state.user.selectedUser
  }

  get facilities () {
    return this.$store.state.facility.facilities
  }

  get tooltip () {
    if (this.facilities && this.facilities.length) {
      let text = '<ul class="tooltip-list">'
      this.facilities.forEach((facility: IFacility) => {
        text += `<li class="tooltip-item">• ${facility.name}</li>`
      })
      text += '</ul>'
      return text
    }
    return ''
  }

  goUserEdit () {
    this.$locationManager.rememberAndGoTo({
      name: 'admin-users-edit',
      params: { id: this.user.id.toString() },
      query: { userChainId: (this.user.chain as IChain).id.toString() }
    })
  }

  getResponsibilityLabel (responsibility: EUserResponsibilities) {
    switch (responsibility) {
      case EUserResponsibilities.BILLING_CONTACT:
        return 'Billing Contact'
      case EUserResponsibilities.MAIL_STATEMENTS:
        return 'Mail Statements'
      case EUserResponsibilities.MANAGER:
        return 'Manager'
      case EUserResponsibilities.REVIEW_PAYMENTS:
        return 'Review Payments'
      case EUserResponsibilities.POST_PAYMENTS:
        return 'Post Payments'
      case EUserResponsibilities.COLLECTIONS:
        return 'Collections'
    }
  }

  @Debounce(500)
  async updateComments () {
    await this.userModuleInstance.updateUser({
      id: this.user.id,
      data: {
        comments: this.user.comments
      },
      type: this.user.type
    })
  }

  getUserStatusLabel (status: EUserStatus) {
    const map: any = {
      [EUserStatus.ACTIVE]: 'Active',
      [EUserStatus.NOT_ACTIVE]: 'Deactivated'
    }
    return map[status]
  }

  async uploadAvatar (event: any) {
    console.log('event', event)
    await this.userModuleInstance.uploadAvatar({
      userId: this.user.id,
      file: event.target.files[0]
    })
    await this.userModuleInstance.fetchUserById(this.user.id)
  }

  getSoftwareList () {
    const softwares: EOrigin[] = []
    this.facilities.forEach((facility: IFacility) => {
      if (facility.origin === EOrigin.NCS && !softwares.includes(EOrigin.NCS)) {
        softwares.push(EOrigin.NCS)
      }
      if (facility.origin === EOrigin.MANUAL && !softwares.includes(EOrigin.MANUAL)) {
        softwares.push(EOrigin.MANUAL)
      }
      if (facility.origin === EOrigin.PCC && !softwares.includes(EOrigin.PCC)) {
        softwares.push(EOrigin.PCC)
      }
    })
    return softwares.join(', ')
  }

  openUploadAvatarModal () {
    // @ts-ignore
    this.$refs.avatarFile.click()
  }
}
